import { render, staticRenderFns } from "./home-temp.vue?vue&type=template&id=3f929afe&scoped=true&"
var script = {}
import style0 from "./home-temp.vue?vue&type=style&index=0&id=3f929afe&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f929afe",
  null
  
)

export default component.exports